import { ColDef, ValueFormatterParams } from '@ag-grid-community/core';
import { UserRecord, UserRole } from '@tassat/fred-definitions';
import { formatAsAsset } from '@tassat/utility';

export const getColumnDef = (opts: {
    currentUser: UserRecord;
    currentRole: UserRole;
}): ColDef[] => {
    const {
        currentUser,
        currentRole
    } = opts;

    const defaultCol: ColDef[] = [
        {
            field: 'PledgeTransactionStatus',
            headerName: 'Status',
            cellRenderer: 'pledgeStatusCellRenderer',
            cellRendererParams: {
                currentUser,
                currentRole
            },
            flex: 4,
            minWidth: 100,
            menuTabs: []
        },
        {
            field: 'PledgeTransactionAmount',
            headerName: 'Amount',
            flex: 6,
            minWidth: 100,
            menuTabs: [],
            valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value, params.context?.asset, 'ticker', undefined, true))
        },
        {
            field: 'PledgeTransactionType',
            headerName: 'Type',
            cellRenderer: 'pledgeTransactionActionRender',
            flex: 5,
            minWidth: 100,
            menuTabs: []
        },
        {
            field: 'PledgeTransactionRequesterAccountName',
            headerName: 'Initiating Account',
            flex: 6,
            minWidth: 100,
            menuTabs: []
        },
        {
            field: 'PledgeTransactionAssetLeavesQuantity',
            headerName: 'Updated Post Amount',
            flex: 6,
            minWidth: 100,
            menuTabs: [],
            valueFormatter: ((params: ValueFormatterParams) => formatAsAsset(params.value, params.context?.asset, 'ticker', undefined, true))
        },
        {
            field: 'PledgeTransactionAuditTime',
            headerName: 'Time',
            cellRenderer: 'dateCellRender',
            menuTabs: [],
            flex: 6,
            minWidth: 100,
            sort: 'desc',
            sortIndex: 0,
            comparator: (a: string, b: string) => Number(a) - Number(b)
        }
    ];

    return defaultCol;
};